import React from 'react';

import { loadingEnd } from "@/utils/ui";
import { myConst } from "@/config/";

import "./index.scoped.css";
import "./appType.scoped.sass";

export default function Loading() {
    const appName = myConst.appName;
    return (
        <div id="loading" className={appName}>
            <div>
                <div id="loadingPic">
                    <img src={`/static/img/loading/${appName}.gif`} alt="" />
                </div>
                <p id="loadingText" className="hidden">请求数据失败，请稍后刷新重试 <br />
                    <span className="btn refresh" onClick={() => { history.go(0); }}>刷新</span> <span className="btn enter" onClick={loadingEnd}>进入</span></p>
            </div>
        </div>
    );
}
